/**
 * 路由守卫组件
 * 保护需要登录才能访问的路由
 */
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserStore } from '@/stores/userStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isLoggedIn = useUserStore((s) => s.isLoggedIn);
  const userId = useUserStore((s) => s.userInfo?.id);
  const refreshIsAdmin = useUserStore((s) => s.refreshIsAdmin);
  const location = useLocation();

  // 进入受保护路由时刷新一次管理员身份（处理刷新/直接 URL 进入场景）
  useEffect(() => {
    if (isLoggedIn && userId) {
      refreshIsAdmin();
    }
  }, [isLoggedIn, userId, refreshIsAdmin]);

  if (!isLoggedIn) {
    // 未登录，重定向到登录页，并保存当前路径
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
